export const ADMIN_PANEL_ROUTE_BASE = 'panel';
export const PEOPLE_ROUTE_BASE = 'people';
export const GROUPS_ROUTE_BASE = 'groups';
export const FAMILIES_ROUTE_BASE = 'families';
